import { render, staticRenderFns } from "./location-view-toolbar.vue?vue&type=template&id=b8f515d6&"
import script from "./location-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./location-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports